const cardSubtitles = document.querySelectorAll(".card-subtitle")
const arrowIcons = document.querySelectorAll(".arrow-accordion")
let width = screen.width;

document.addEventListener('DOMContentLoaded', () => {
    Array.from(cardSubtitles).forEach(subtitle => {
        if(width <= 768) {
            subtitle.classList.add("hidden")
        }
    })
})

Array.from(arrowIcons).forEach((item) => {
    item.addEventListener("click", () => {
        const closestText = item.parentElement.nextSibling.nextSibling.nextSibling.nextSibling
        if(closestText.classList.contains("open")) {
            closestText.classList.remove("open")
            item.classList.remove("rotated")
        } else {
            closestText.classList.add("open")
            item.classList.add("rotated")
        }
    })
})





